import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const PersonalFormSkeleton = () => <MultipleInputSkeleton count={5} />

export default memo(PersonalFormSkeleton)
